import { createModule, makeAsset } from "../../utils";

export const unitSystem = createModule("unitSystem", {
  unit: makeAsset
});
